import { Box, styled } from '@mui/material'
import { rgba } from 'polished'

import { statusChipBase } from 'components/Status/Status.styles'

import { theme } from 'styles/theme'

const statusModifiers = {
  analysing: {
    color: theme.palette.neutral[400],
    background: rgba(theme.palette.neutral[700], 0.3)
  },
  processing: {
    color: theme.palette.alert[300],
    background: rgba(theme.palette.alert[300], 0.3)
  },
  waiting_return: {
    color: theme.palette.alert[300],
    background: rgba(theme.palette.alert[300], 0.3)
  },
  negativated: {
    color: theme.palette.error[300],
    background: rgba(theme.palette.error[300], 0.3)
  },
  recovering: {
    color: theme.palette.primary[300],
    background: rgba(theme.palette.primary[300], 0.3)
  },
  recovered: {
    color: theme.palette.primary[300],
    background: rgba(theme.palette.primary[300], 0.3)
  },
  cancelling: {
    color: theme.palette.error[300],
    background: rgba(theme.palette.error[300], 0.3)
  },
  cancelled: {
    color: theme.palette.error[300],
    background: rgba(theme.palette.error[300], 0.3)
  },
  failed: {
    color: theme.palette.error[300],
    background: rgba(theme.palette.error[300], 0.3)
  }
}

type StatusProps = {
  status: string
}

export const Status = styled('div')<StatusProps>(({ status }) => ({
  ...statusChipBase,
  ...statusModifiers[status]
}))

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gridTemplateColumns: '1fr 1fr',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px',
  marginBottom: 0,
  marginRight: '16px',
  width: '100%',
  [theme.breakpoints.down(600)]: {
    flexDirection: 'column',
    alignItems: 'start'
  }
}))
